import moment from 'moment';
import React from 'react';

interface TaskStatusBadgeProps {
  deadline: string;
  status: string;
}

const TaskStatusBadge = (props: TaskStatusBadgeProps) => {
  const { deadline, status } = props;

  const getTaskClass = (deadline: string, status: string) => {
    const date = moment(deadline);

    if (status === 'finished') return 'success';

    if (date.isBefore(moment(), 'day')) return 'danger';
    if (date.isSame(moment(), 'day')) return 'warning';
    return 'info';
  };

  const getTaskLabel = (deadline: string, status: string) => {
    const date = moment(deadline);

    if (status === 'finished') return 'Concluída';

    if (date.isBefore(moment(), 'day')) return 'Atrasada';
    if (date.isSame(moment(), 'day')) return 'Hoje';
    return 'Futura';
  };

  return (
    <span className={`badge badge-pill badge-${getTaskClass(deadline, status)} px-2 py-1`}>
      {getTaskLabel(deadline, status)}
    </span>
  );
};

export default TaskStatusBadge;
